<script>
import {computed, defineComponent} from "vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {useStore} from "vuex";

export default defineComponent({
  components: {DataTable, Column},
  props: {
    segments: {
      type: Array,
      required: true
    },
    buildingId: {
      type: Number,
      required: true,
    }
  },
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLang);
    return {
      lang,
    }
  },
});
</script>

<template>
  <DataTable :value="segments" showGridlines tableStyle="min-width: 50rem" selectionMode="single">
    <Column field="id" header="ID"></Column>
    <Column field="title" header="Наименование сегмента">
      <template #body="slotProps">
        <router-link :to="{name: 'building-segment-edit', params: {id: buildingId, segment: slotProps.data.id}}">
          {{ slotProps.data.title }}
        </router-link>
      </template>
    </Column>
    <Column field="categories_count" header="Категории"></Column>
    <Column field="rooms_count" header="Объекты"></Column>
  </DataTable>
</template>

<style scoped>

</style>